import React from 'react';
import { motion } from 'framer-motion';

const Philosophy = () => {
  return (
    <section id="filosofi" className="py-24 md:py-32 bg-stone-900 text-stone-100">
      <div className="container mx-auto px-6 md:px-12 text-center max-w-4xl">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <span className="block text-xs uppercase tracking-[0.2em] text-stone-400 mb-6">
            Min Filosofi
          </span>
          <h2 className="text-3xl md:text-5xl font-medium mb-10 font-serif leading-tight">
            "Jag tror inte på snabba lösningar eller tillfälliga dieter."
          </h2>
          
          <div className="space-y-6 text-stone-300 font-light leading-relaxed text-lg mx-auto max-w-3xl text-left md:text-center">
            <p>
              Min filosofi bygger på balans, långsiktighet och individuella lösningar som fungerar i din vardag. Oavsett om ditt mål är att bli starkare, förbättra din teknik, gå ner i vikt, få mer energi eller skapa bättre hälsovanor får du ett upplägg som utgår från dina förutsättningar och mål.
            </p>
            <p>
              Mitt mål är att du inte bara ska nå dina resultat – utan också känna dig trygg, motiverad och få kunskap som hjälper dig att behålla dem över tid.
            </p>
          </div>
        </motion.div>

        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="mt-24 pt-24 border-t border-stone-800 text-left"
        >
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-2xl md:text-3xl font-serif mb-6">
                För dig som känner att kroppen har förändrats
              </h3>
              <div className="space-y-4 text-stone-400 font-light">
                <p>
                  Jag hjälper främst kvinnor 30+, män är givetvis också välkomna, som upplever att kroppen inte längre känns som den gjorde tidigare.
                </p>
                <p>
                  Kanske har kroppen förändrats efter en graviditet, i samband med hormonella förändringar eller genom en period med hög stress och stort ansvar. Du kanske känner dig tröttare, svagare eller upplever att träningen inte längre ger samma resultat som tidigare.
                </p>
                <p>
                  Hos mig möts du av förståelse, kunskap och ett individanpassat upplägg.
                </p>
              </div>
            </div>
            <div className="bg-stone-800 p-8 md:p-12 hidden md:block">
              <p className="text-xl font-serif italic text-stone-300 leading-relaxed">
                "Mitt mål är att du ska känna dig stark, frisk och trygg i din kropp, oavsett var du befinner dig i livet."
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Philosophy;